import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useCurrentUser } from './api/useUsers'
import { isSupportedLang } from '../i18n'

/**
 * Hydrates i18next with the authenticated user's preferred_language.
 * Mount once inside the authenticated tree (e.g. ProtectedApp).
 * Until the user query resolves, i18next stays on the LanguageDetector pick
 * (localStorage or navigator), which avoids a blocking spinner on first paint.
 */
export function useSyncUserLanguage() {
  const { i18n } = useTranslation()
  const { data: user } = useCurrentUser()

  useEffect(() => {
    const lang = user?.preferred_language
    if (!lang || !isSupportedLang(lang)) return
    if (i18n.language === lang) return
    void i18n.changeLanguage(lang)
  }, [user?.preferred_language, i18n])
}
